import { produce } from 'immer';
import { map } from 'lodash/fp';

import { DELETE_PROJECT_SUCCESS_PROJECT_DELETED } from 'app/store/__generated__/events';

import { SIGN_OUT } from 'app/store/users/types.js';
import { DELETE_VIEW } from 'app/store/entities/types.js';
import { SEARCH_PROJECTS, SELECT_PROJECT } from './types.js';

export const INITIAL_STATE = {
    term: '',
    isLoading: false,
    facets: null,
    totalResults: 0,
    resultsByEntityId: {},
    resultIds: [],
    selectedProjectId: null
};

function storeEntity(draft, entity) {
    if (!draft.resultsByEntityId.hasOwnProperty(entity.entityId)) {
        draft.resultsByEntityId[entity.entityId] = {};
    }

    Object.assign(draft.resultsByEntityId[entity.entityId], entity);
}

export const searchReducer = produce((draft, action) => {
    switch (action.type) {
        case SEARCH_PROJECTS.STARTED: {
            draft.isLoading = true;
            draft.resultsByEntityId = {};
            draft.resultIds = [];
            return;
        }

        case SEARCH_PROJECTS.SUCCEEDED: {
            for (const result of action.payload.results) {
                storeEntity(draft, result);
            }
            draft.resultIds = map('entityId', action.payload.results);
            draft.facets = action.payload.facets;
            draft.totalResults = action.payload.totalResults;
            draft.term = action.payload.term;
            return;
        }

        case SEARCH_PROJECTS.FAILED:
            draft.term = '';
            draft.resultIds = [];
            draft.isLoading = false;
            draft.totalResults = 0;
            break;

        case SEARCH_PROJECTS.ENDED:
            draft.isLoading = false;
            break;

        case DELETE_VIEW.SUCCEEDED: {
            const { entityId } = action.payload.viewRef;

            if (entityId in draft.resultsByEntityId) {
                draft.totalResults -= 1;
            }

            delete draft.resultsByEntityId[entityId];
            draft.resultIds.splice(draft.resultIds.indexOf(entityId), 1);

            break;
        }

        case SELECT_PROJECT:
            draft.selectedProjectId = action.params.projectId;
            break;

        case DELETE_PROJECT_SUCCESS_PROJECT_DELETED: {
            const uid = action.payload.assetId;
            if (uid in draft.resultsByEntityId) {
                draft.totalResults -= 1;
            }
            delete draft.resultsByEntityId[uid];
            if (draft.selectedProjectId === uid) {
                draft.selectedProjectId = null;
            }
            draft.resultIds.splice(draft.resultIds.indexOf(uid), 1);

            break;
        }

        case SIGN_OUT:
            return INITIAL_STATE;

        default:
    }
}, INITIAL_STATE);
